'use client'

import dynamic from 'next/dynamic'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { MenuList, MenuItem } from '@mui/material'

// Types
import type { MenuProps } from '@/types/components/organisms/menu'

// Helpers
import { useTranslation } from '@/helpers/i18n/client'

// Component
const MenuButtonAtom = dynamic(() => import('@/components/atoms/buttons/menu'))

const MenuOrganism = (props: MenuProps) => {
	// Props
	const { lng, items, setOpen } = props

	// Variables
	const { t } = useTranslation(lng)
	const pathname = usePathname()

	return (
		<MenuList
			sx={{
				display: 'flex',
				py: 0
			}}
		>
			{items.map((item, index) => {
				if (item.link_value !== '/home') {
					const link = `/${lng}${item.link_value}`
					const isActive = pathname.indexOf(`${link}/`) === 0
					const isCurrent = pathname === link

					return (
						<MenuItem
							className={(item.link_value !== `/${lng}` && isActive) || isCurrent ? 'selected' : undefined}
							disableRipple
							disableTouchRipple
							key={index}
							sx={{ '&:hover': { bgcolor: 'transparent' } }}
						>
							<Link
								href={link}
								onClick={() => {
									if (setOpen) setOpen(false)
								}}
							>
								<MenuButtonAtom selected={(link !== `/${lng}` && isActive) || isCurrent}>{t(item.title)}</MenuButtonAtom>
							</Link>
						</MenuItem>
					)
				} else return null
			})}
		</MenuList>
	)
}

export default MenuOrganism
